import React, {useState} from "react";
import styles from "../styles";
import Survey from "../components/Survey";
import {apiCreateSurvey, apiDeleteSurvey} from "../api/surveys";
import {VisibilityPicker} from "./AdminPage";
import {useToast, useConfirm} from "../components/FeedbackProvider";

export default function SurveysPage({surveys, user, selectedGroup, groups, answers, onRefresh}) {
    const {notify} = useToast();
    const confirm = useConfirm();
    const [surveyQuestion, setSurveyQuestion] = useState("");
    const [surveyVisibility, setSurveyVisibility] = useState([]);
    const isAdmin = user?.role === "admin";

    function createSurvey() {
        if (!selectedGroup || surveyQuestion.trim() === "") return;
        apiCreateSurvey(selectedGroup.id, surveyQuestion, surveyVisibility).then(data => {
            if (data.error) { notify(data.error, "error"); return; }
            setSurveyQuestion("");
            setSurveyVisibility([]);
            onRefresh();
        });
    }

    async function deleteSurvey(surveyId) {
        if (!(await confirm("Supprimer ce sondage ?", {danger: true}))) return;
        apiDeleteSurvey(surveyId).then(onRefresh);
    }

    return (
        <>
            {isAdmin && (
                <div style={styles.card}>
                    <h3 style={{fontFamily: "'Fraunces', serif"}}>📊 Nouveau sondage Paroles d'Agents</h3>
                    <textarea
                        value={surveyQuestion}
                        onChange={e => setSurveyQuestion(e.target.value)}
                        placeholder="Posez une question aux agents..."
                        style={{...styles.input, height: 100}}
                    />
                    <VisibilityPicker groups={groups || []} value={surveyVisibility} onChange={setSurveyVisibility}/>
                    <button onClick={createSurvey} style={styles.button}>Publier le sondage</button>
                </div>
            )}

            {surveys.length === 0 && (
                <p style={{color: "#6B7280", fontSize: 14, textAlign: "center", marginTop: 24}}>
                    Aucun sondage en cours dans ce collectif. Les prochains proposés par vos représentants apparaîtront ici.
                </p>
            )}

            {surveys.map(survey => (
                <div key={survey.id}>
                    <Survey survey={survey} user={user} answers={answers}/>
                    {isAdmin && (
                        <div style={{marginBottom: 8, marginTop: -4}}>
                            <button onClick={() => deleteSurvey(survey.id)} style={styles.dangerButton}>
                                Supprimer ce sondage
                            </button>
                        </div>
                    )}
                </div>
            ))}
        </>
    );
}
